import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import './WhatsAppIcon.css';
import logo from "../static/media/logo.webp";

const WhatsAppIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const whatsappLink = "https://wa.me/593984813777";

  return (
    <>
      <div className={`whatsapp-popup ${isOpen ? "open" : ""}`}>
        <div className="popup-header">
          <div className="popup-header-content">
            <p className="popup-title">¡Hola!</p>
            <p className="popup-message">
              Haz clic en nuestro contacto a continuación para chatear en WhatsApp
            </p>
          </div>
          <button
            className="popup-close"
            onClick={() => setIsOpen(false)}
            aria-label="Cerrar ventana de WhatsApp"
          >
            <FaTimes aria-hidden="true" />
          </button>
        </div>

        <div className="popup-body">
          <a
            href={whatsappLink}
            className="popup-contact"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ir a WhatsApp de servicio al cliente"
          >
            <img src={logo} alt="Logo de CMSOLTEC" className="popup-logo" />
            <div className="popup-contact-info">
              <p className="popup-contact-title">Servicio al cliente</p>
              <p className="popup-contact-subtitle">CMSOLTEC SERVICES</p>
            </div>
          </a>
        </div>
      </div>

      <button
        className="whatsapp-icon"
        onClick={() => setIsOpen(true)}
        aria-label="Abrir chat de WhatsApp"
      >
        <FaWhatsapp aria-hidden="true" />
      </button>
    </>
  );
};

export default WhatsAppIcon;
